import { useState } from 'react';
import { DiagnosticsData } from '../../../shared/types/diagnosticsData.ts';
import { ModalSubmitDialog } from '../../components/modalSubmitDialog.tsx';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    isOpen: boolean;
    diagnostics: DiagnosticsData | undefined,
    onRestartCalled: () => void;
    onClose: () => void;
}

export function RestartDialog({
    isOpen,
    diagnostics,
    onRestartCalled,
    onClose,
}: Props) {
    const [feedback, setFeedback] = useState('');

    const restartServer = trpc.serverState.restartServer.useMutation();

    async function handleSubmit() {
        await restartServer.mutateAsync({
            userMessage: feedback,
            diagnosticsData: diagnostics,
        });
        onRestartCalled();
    }

    return (
        <ModalSubmitDialog
            frameStyle={{ width: '600px' }}
            isOpen={isOpen}
            isSubmitting={restartServer.isPending}
            submitButtonText='Restart'
            onCancel={onClose}
            onSubmit={handleSubmit}
        >
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>Restart app</div>
            <p>This will only restart the app itself and will not fix any issues in MT-LINKi or the app database.</p>
            <p>Describe in detail why a restart is needed: what is not working and what you are seeing. This is to help the development team understand and fix the issue.</p>
            <textarea
                style={{ width: '100%', padding: '8px' }}
                rows={3}
                value={feedback}
                onChange={e => setFeedback(e.target.value)}
            />
        </ModalSubmitDialog>
    );
}
